import { render } from "./DatabaseExport.vue?vue&type=template&id=0511b7ea"
import script from "./DatabaseExport.vue?vue&type=script&lang=js"
export * from "./DatabaseExport.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DatabaseExport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0511b7ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0511b7ea', __exports__)) {
    api.reload('0511b7ea', __exports__)
  }
  
  module.hot.accept("./DatabaseExport.vue?vue&type=template&id=0511b7ea", () => {
    api.rerender('0511b7ea', render)
  })

}


export default __exports__